import declare from "dojo/_base/declare";
import DataSheetItemsPasteForm from "src/SiteAdmin/DataSheet/Paste/DataSheetItemsPasteForm";

const RecipePasteForm = declare(DataSheetItemsPasteForm, {
	_configNodeType: "RecipeItemsImportConfiguration",
	_configViewId: "RecipeItemsImportConfigurations",
	_lineItemNodeType: "RecipeLineItem",
});

export = RecipePasteForm;
